var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87891 2.8801C2.87891 2.17317 3.45198 1.6001 4.15891 1.6001H9.27891C9.44865 1.6001 9.61143 1.66753 9.73145 1.78755L12.9315 4.98755C13.0515 5.10757 13.1189 5.27036 13.1189 5.4401V13.1201C13.1189 13.827 12.5458 14.4001 11.8389 14.4001H4.15891C3.45198 14.4001 2.87891 13.827 2.87891 13.1201V2.8801ZM9.01381 2.8801L4.15891 2.8801V13.1201H11.8389V5.70519L9.01381 2.8801Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63891 1.6001C8.99237 1.6001 9.27891 1.88664 9.27891 2.2401V5.4401H12.4789C12.8324 5.4401 13.1189 5.72664 13.1189 6.0801C13.1189 6.43356 12.8324 6.7201 12.4789 6.7201H8.63891C8.28544 6.7201 7.99891 6.43356 7.99891 6.0801V2.2401C7.99891 1.88664 8.28544 1.6001 8.63891 1.6001Z",
    fill: "#21272F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43891 8.6401C5.43891 8.28664 5.72544 8.0001 6.07891 8.0001H9.91891C10.2724 8.0001 10.5589 8.28664 10.5589 8.6401C10.5589 8.99356 10.2724 9.2801 9.91891 9.2801H6.07891C5.72544 9.2801 5.43891 8.99356 5.43891 8.6401Z",
    fill: "#21272F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43891 11.2001C5.43891 10.8466 5.72544 10.5601 6.07891 10.5601H9.91891C10.2724 10.5601 10.5589 10.8466 10.5589 11.2001C10.5589 11.5536 10.2724 11.8401 9.91891 11.8401H6.07891C5.72544 11.8401 5.43891 11.5536 5.43891 11.2001Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUpload);
export default __webpack_public_path__ + "static/media/bulkUpload.40b6dac6dd28161f6355c3d33c54cef7.svg";
export { ForwardRef as ReactComponent };